import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

const QuestionsListHeader = ({ source }) => {
  const showThirdColumn = ['review', 'engagement'].includes(source);

  return (
    <Container>
      <Grid container>
        <Grid item xs={showThirdColumn ? 6 : 7}>
          <StyledTypography weight={600} variant="body2" color="#999">
            Name
          </StyledTypography>
        </Grid>
        <Grid item xs={showThirdColumn ? 2 : 3}>
          <StyledTypography weight={600} variant="body2" color="#999">
            Answer
          </StyledTypography>
        </Grid>
        {showThirdColumn && (
          <Grid item xs={4}>
            <StyledTypography weight={600} variant="body2" color="#999">
              {source === 'review' ? 'Type' : 'Driver'}
            </StyledTypography>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 1.5rem;
`;

export default QuestionsListHeader;
